import {data} from './data';

export const howDoWeDoIt = {
	data,
	title: 'Ako to robíme',
};
